import { render, staticRenderFns } from "./budget-status.vue?vue&type=template&id=1ed2d291&scoped=true"
import script from "./budget-status.vue?vue&type=script&lang=js"
export * from "./budget-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed2d291",
  null
  
)

export default component.exports